// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3pRhr","content":"content--2-rs_","title":"title--1CLSP","select_language":"select_language--3uVYv"};